import React, { useEffect, useState } from "react";
import { useData } from "../util/dataProvider";

export default function MarkerDetails({ company, detailsShow }) {
    const { getColor } = useData();
    return (
        <div
            className={`marker-details`}
            style={{
                transform: `scale(${
                    detailsShow && company.id === detailsShow.id ? 1.2 : 1
                }) translateY(${ detailsShow && company.id === detailsShow.id ? '15px' : '0'})`,
                backgroundColor:"red",
                position: "absolute",
                zIndex: detailsShow && company.id === detailsShow.id ? -1 : 0,
                
            }}>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='50pt'
                height='50pt'
                viewBox='0 0 50 50'
                version='1.1'
                style={{
                    position: "absolute",
                    zIndex: detailsShow && company.id === detailsShow.id ? -1 : 0,
                }}>
                <g>
                    <path
                        style={{
                            stroke: "none",
                            fillRule: "nonzero",
                            fill: getColor(company.category),
                            fillOpacity: 1,
                        }}
                        d='M 25 1 C 16.179688 1 9 8.179688 9 17 C 9 31.113281 23.625 47.949219 24.246094 48.660156 C 24.4375 48.875 24.710938 49 25 49 C 25.308594 48.980469 25.566406 48.871094 25.757812 48.652344 C 26.378906 47.929688 41 30.8125 41 17 C 41 8.179688 33.820312 1 25 1 Z M 25 24 C 21.6875 24 19 21.3125 19 18 C 19 14.6875 21.6875 12 25 12 C 28.3125 12 31 14.6875 31 18 C 31 21.3125 28.3125 24 25 24 Z M 25 24 '
                    />
                </g>
            </svg>
        </div>
    );
}
